import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import * as actions from './redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CreateFormForPlugin from '../../common/formElements/CreateFormForPlugin';
import CustomLoader from '../common/CustomLoader';
import { Mixpanel } from '../../common/utils/mixpanelUtil';
import ParentDocCard from '../common/ParentDocCard';
import CardTitleHeader from '../../common/ui/CardTitleHeader';
import { pluginCode } from 'drapcode-constant';

const option = {
  DO_NOT_NEED_SECURITY: "I don't need security as all my data and pages will be public",
  DEFAULT_SETTING: 'I want to choose default security settings',
  CUSTOMIZED: 'I want to customise security settings',
  WILL_DO_IT_LATER: 'Skip, I will do it later',
};
export class DefaultPage extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    status: '',
    showLoginPluginForm: false,
    showProceedBtn: false,
  };

  componentDidMount() {
    const { projectId, version } = this.props.match.params;
    this.props.actions.loadLoginPluginConfiguration({
      version,
      loginPluginCode: pluginCode.LOGIN,
      projectId,
    });
  }

  changeOption = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState({ [name]: value, showProceedBtn: true });
  };

  sendRequestToServerForLoginPlugin = async (values) => {
    const { match, projectOnBoard, actions, history } = this.props;
    const { projectId, version } = match.params;
    const { code } = projectOnBoard.loginPluginDetail;

    const formData = {
      pluginCode: code,
      keystore: JSON.stringify(values),
      isEnabled: true,
      projectId: projectId,
      version,
    };
    await actions.installLoginPlugin(formData).then(() => {
      history.push(`/project-on-board/${version}/v/${projectId}/add-collection`);
    });
  };

  createSchemaForPluginConfiguration = () => {
    const { fields } = this.props.projectOnBoard.loginPluginDetail;
    let schema = {};
    if (fields) {
      Object.entries(fields).forEach(([key, value]) => {
        schema[key] = value.value || value.value === false ? value.value : '';
      });
    }

    return schema;
  };

  prepareValidationForPluginConfiguration = () => {
    const { fields } = this.props.projectOnBoard.loginPluginDetail;
    let validationSchema = {};
    if (fields) {
      Object.keys(fields).forEach((field) => {
        const fieldDetail = fields[field];
        if (fieldDetail.required) {
          let yupDetail = '';
          if (fieldDetail.type === 'text' || fieldDetail.type === 'password') {
            yupDetail = Yup.string().required("Can't be blank");
          } else if (fieldDetail.type === 'number') {
            yupDetail = Yup.number().required("Can't be blank");
          } else if (fieldDetail.type === 'email') {
            yupDetail = Yup.string().email('Not a valid email').required("Can't be blank");
          }
          validationSchema[field] = yupDetail;
        }
      });
    }
    return Yup.object().shape(validationSchema);
  };

  handleSubmit = async (values, resetForm) => {
    await this.sendRequestToServerForLoginPlugin(values);
    resetForm();
  };

  showCustomizeLoginPluginForm = () => {
    const { showLoginPluginForm } = this.state;
    if (showLoginPluginForm) {
      const { projectOnBoard } = this.props;
      const { loadLoginPluginConfigurationPending, loginPluginDetail } = projectOnBoard;
      if (loadLoginPluginConfigurationPending) {
        return 'Loading';
      }
      const { name, fields, code } = loginPluginDetail;
      return (
        <Fragment>
          <CardTitleHeader title="Customise Security Settings" />
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <div className="card-description mb-4">
              <h5>
                Select the fields given below that you want a user to fill in the login/sign up form
                to access private pages.
              </h5>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-lg-12 col-xs-12">
              <CardTitleHeader title="Sign Up Form Fields" />
              <Formik
                initialValues={this.createSchemaForPluginConfiguration()}
                validationSchema={this.prepareValidationForPluginConfiguration()}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  this.handleSubmit(values, resetForm);
                  setSubmitting(false);
                }}
              >
                <Form className="form-horizontal">
                  {fields && !_.isEmpty(fields) ? (
                    <div className="row">
                      {Object.keys(fields).map((key, index) => (
                        <div className="col-md-6 col-lg-6 col-xs-12 col-sm-12" key={key}>
                          <CreateFormForPlugin name={key} field={fields[key]} />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <h4>
                        <i className={`wb ${drapcodeIcon('info')}`}></i> Please click the Install
                        Plugin button.
                      </h4>
                    </div>
                  )}

                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
                    <button type="submit" className="btn btn-theme-submit">
                      <i className={`wb ${drapcodeIcon('install')}`}></i>
                      &nbsp;Activate Authentication&nbsp;
                      <CustomLoader
                        loading={
                          loadLoginPluginConfigurationPending !== undefined &&
                          loadLoginPluginConfigurationPending
                        }
                      />
                    </button>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </Fragment>
      );
    }
    return;
  };

  proceedToNextStep = () => {
    const { status } = this.state;
    const { match, history, actions } = this.props;
    const { projectId, version } = match.params;
    Mixpanel.track(`Clicked on- Proceed button with- ${option[status]}`);
    if (status === 'DEFAULT_SETTING') {
      const values = {
        first_name: false,
        last_name: false,
        userName: true,
        password: true,
        address: false,
        country: false,
        date_of_birth: false,
        email: false,
        gender: false,
        is_email_verified: false,
        is_enabled: false,
      };
      this.sendRequestToServerForLoginPlugin(values);
      return;
    } else if (status === 'DO_NOT_NEED_SECURITY') {
      actions
        .changeProjectStatus({
          state: 'LOGIN_PLUGIN',
          status: 'COMPLETE',
          projectId,
          version,
        })
        .then((res) => {
          history.push(`/project-on-board/${version}/v/${projectId}/add-collection`);
        });
    } else if (status === 'WILL_DO_IT_LATER') {
      actions
        .changeProjectStatus({
          state: 'LOGIN_PLUGIN',
          status: 'PENDING',
          projectId,
          version,
        })
        .then((res) => {
          history.push(`/project-on-board/${version}/v/${projectId}/add-collection`);
        });
    } else if (status === 'CUSTOMIZED') {
      this.setState({ showLoginPluginForm: true });
    }
  };

  getButtonText = () => {
    const { status } = this.state;
    if (!status) {
      return 'Proceed';
    }
    if (status === 'CUSTOMIZED') {
      return 'Proceed: Customize Authorization';
    }

    return 'Proceed: Add Collection';
  };

  render() {
    const { showLoginPluginForm, showProceedBtn } = this.state;
    return (
      <div className="main">
        <div className="section">
          <div className="container">
            <div className="row mx-auto">
              <div className="col-md-9 col-lg-9 col-sm-9 col-xs-12 drapcode">
                <div className="card">
                  <div
                    className="card-header card-header-icon"
                    data-background-color="drapcode-violet"
                  >
                    <i className={`wb ${drapcodeIcon('plugins')}`}></i>
                  </div>
                  <div className="card-content">
                    {!showLoginPluginForm && (
                      <Fragment>
                        <CardTitleHeader title="Need Authentication In Your Project" />
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                          <div className="card-description mb-4">
                            <h5>
                              Add role-based security on some web pages in your app to keep your
                              data and pages secure and private from the users.
                            </h5>
                          </div>
                        </div>
                        <div className="row mx-auto project-on-board-login-plugin">
                          <div className="col-md-11 col-lg-11 col-sm-11 col-xs-12 mx-auto">
                            {Object.keys(option).map((opt) => (
                              <div className="form-check">
                                <label className="form-check-label pr-0 pb-0 pt-0">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="status"
                                    value={opt}
                                    onChange={this.changeOption}
                                  />
                                  {option[opt]}
                                  <span className="circle">
                                    <span className="check"></span>
                                  </span>
                                </label>
                              </div>
                            ))}
                          </div>

                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
                            {showProceedBtn ? (
                              <button className="btn btn-primary" onClick={this.proceedToNextStep}>
                                <i className={`wb ${drapcodeIcon('next')}`}></i>&nbsp;
                                {this.getButtonText()}
                              </button>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </Fragment>
                    )}
                    {this.showCustomizeLoginPluginForm()}
                  </div>
                </div>
              </div>
              <ParentDocCard></ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
